import React from 'react';
import {AppBar} from '@material-ui/core'
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';


const useStyles = makeStyles(theme => ({    
    menuButton: {
        marginRight: theme.spacing(2),
    },
    toolbar:{
        justifyContent: 'center',
        padding:theme.spacing(2,0,0,0)
    },
    title: {
        // flexGrow: 1,
        // alignContent: "center",
        // display: 'flex',        
        // justifyContent: 'center',
        color: theme.palette.text.white,
                   
    },
    title_icon: {
        fontSize: '30px',
        paddingRight: theme.spacing(1)
    },
    title_text: {
        letterSpacing: '0px',
        fontSize: '16px', 
        lineHeight:1.5,
        padding: theme.spacing(1,0),
        fontWeight: 700,
        textAlign:"center"
    },
    title_sub_text: {

    }
    
}));

function Header(){

    const classes = useStyles();
    

    return (
                    
        <AppBar
            color="transparent"
            elevation={0}
            position="static"
        >                
            <Toolbar
                className={classes.toolbar}
            > 
                <div className={classes.title}>
                    {/* <QuestionAnswerIcon className={classes.title_icon}/> */}
                    <Typography variant="h1" className={classes.title_text}>                    
                    醫療財團法人辜公亮基金會和信治癌中心醫院<br/>門禁通關線上申請系統

                        {process.env.REACT_APP_HOST=="emr"?<React.Fragment><br/>(員工代填)</React.Fragment>:null}
                    </Typography>
                    <Typography variant="body2" className={classes.title_sub_text}>
                    　　為防堵嚴重特殊傳染性肺炎（COVID-19）及保護癌症病人，嚴格限制進入醫
                            院人員，並依指揮中心規定調查旅遊史、 健康史、群聚史，及職業別和接觸史(TOCC)，
                            請據實填寫以下，如隱匿不實將受傳染病防治法等法規追訴究責。


                    </Typography>
                </div>                                   
            </Toolbar>
        </AppBar>
           
    )
}

export default Header